import { BaseModel } from './base-model';
import { environment } from 'src/environments/environment';

export class Mail extends BaseModel {

	public id: string;
	public host: string;
	public port: number;
	public displayName: string;
	public username: string;
	public password: string;
	public useTLS: boolean;
	public useSSL: boolean;
	public clientId: string;
  	public secret: string;
  	public tenantId: string;
  	public scope: string;
  	public redirectUri: string;
  	public responseMode: string;
  	public responseType: string;
  	public mailAuthType: MailAuthType

	constructor() {
		super();
		this.id = null;
		this.host = null;
		this.port = null;
		this.displayName = null;
		this.username = null;
		this.password = null;
		this.useTLS = false;
		this.useSSL = false;
		this.clientId = null
		this.secret = null
		this.tenantId = null
		this.scope = null
		this.redirectUri = environment.baseUrl + environment.baseApi + 'mailconfiguration/token';
		this.responseMode = null
		this.responseType = null
		this.mailAuthType = null
	}

}

export enum MailAuthType {
  BASIC_AUTH,
  OAUTH2
}
